
import Vue from 'vue'
import Component from "vue-class-component";

/**
 * @deprecated This component won't be extended, in the future we will implement this feature in the bonomo for the
 * whole top bar
 */
@Component({
  name: 'ResponsiveTopMenu',
  components: {
  }
})
export default class ResponsiveTopMenu extends Vue {
  private showContextMenu: boolean = false;

  protected onShowContextMenu(e: MouseEvent) {
    e.preventDefault();
    this.showContextMenu = false;
    setTimeout(() => this.showContextMenu = true);
  }
}
